import React from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionsEnum } from 'utils';
import { extractPermission, PermissionElementAttrEnum } from 'pages/administration.page';

/**
 * @param {policyModel} policy
 * @param {Function} onChange
 * @return {*}
 * @constructor
 */
export const UploadPermission = ({ policy, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="rights">
      <input
        type="checkbox"
        {...{
          [PermissionElementAttrEnum.PERMISSION_NAME]: PermissionsEnum.UPLOAD_PERMISSION,
          [PermissionElementAttrEnum.POLICY_ID]: policy.id,
          [PermissionElementAttrEnum.POLICY_NAME]: policy.organizationGroup,
        }}
        defaultChecked={extractPermission(policy.permissions, PermissionsEnum.UPLOAD_PERMISSION) !== null}
        onChange={onChange}
      />
      <div className="admin-label">{t('video_upload')}</div>
    </div>
  );
};
